import { HiOutlineDocument } from "react-icons/hi";

import { CHAT_ALLOWED_MIME_TYPES_SET } from "@/components/chat/attachments";

const allowedFileTypes: Set<string> = CHAT_ALLOWED_MIME_TYPES_SET;

export const getFileIcon = (file: File) => {
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (extension === "png" || extension === "jpg" || extension === "jpeg") {
    const url = URL.createObjectURL(file);
    return (
      <img
        src={url}
        alt={extension}
        className="h-5 w-5 rounded-md object-cover"
      />
    );
  }
  return <HiOutlineDocument size={20} className="flex-shrink-0 text-primary" />;
};

export function validateFile(
  file: File,
  currentCombinedSize: number,
): { isValid: boolean; message: string } {
  const maxCombinedSize = 700 * 1024; // 700 KB

  if (!allowedFileTypes.has(file.type)) {
    return { isValid: false, message: "File type is not allowed." };
  }

  if (currentCombinedSize + file.size > maxCombinedSize) {
    return {
      isValid: false,
      message: "File size exceeds the maximum allowed limit.",
    };
  }

  return { isValid: true, message: "File is valid." };
}
